import req from './../../fetch';
import { paramsToString, undocumentedResponse } from './../../utils';
import { AllAPIResponses, CarbonError, PermissionType } from './../../index';

type Params = {
  onlyGranted?: boolean;
};

const get = async (
  params: Params,
  headers?: Headers
): Promise<AllAPIResponses<PermissionType[]>> => {
  try {
    const resp = await req.get(
      `/api/permissions${paramsToString(params)}`,
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as PermissionType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
